(function () {

    'use strict';

    angular.module('Services').factory('RoutesTableService', RoutesTableService);
    RoutesTableService.$inject = [
        '$q',
        'FleetService',
        'Carrier',
        'TableLiteFactory',
        '$filter',
        'toastr',
        '$location'
    ];
    function RoutesTableService(
        $q,
        FleetService,
        Carrier,
        TableLiteFactory,
        $filter,
        toastr,
        $location
    ) {
        return function (defaultFilters, area) {
            let selectedArea = null;
            let tableData = {
                tableName: 'RoutesTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'ADD NEW',
                        tooltip: 'Click to create a new Route',
                        onClick: function () {
                            $location.path('/areas/routes/add');
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false
                },
                headers: [{
                    label: 'Route Code',
                    viewName: 'code',
                    filterName: 'code',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Route Name',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Number of Waypoints',
                    viewName: 'waypointCount',
                    filterName: 'waypointCount',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Area',
                    viewName: 'areaId',
                    filterName: 'area.id',
                    sortName: 'area.areaId',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'areaId',
                        filterBy: 'id',
                        items: [], //List of items shown in dropdown
                        onSubmit: function (header) {
                            selectedArea = this.model;
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refreshOnLoad: false,
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            FleetService.Areas.getAll((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (area) => {
                                    filterItems.push(area);
                                });
                                defer.resolve();
                            }, (error) => {
                                toastr.error('Unable to fetch areas', error.message);
                                defer.reject();
                            }, {size: 100, name: model ? model : ''});
                            return defer.promise;
                        },
                        model: area
                    },
                    headerFn: function () {
                        tableActions.sort(this.sortName);
                    }
                }, {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Active', 'Inactive'],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model === 'Active';
                            tableActions.sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }],
                data: [],
                extractTable: function (form) {

                },
                resetFilters: ()=>{
                    tableActions.resetFilters();
                },
                onInit: function () {
                    tableActions.sendRequest({});
                }
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: FleetService.Routes.getRoutes,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'id,asc'
                    }, defaultFilters)
                }
            );

            function buildTableData(data) {
                /*** START - Building of Data ***/
                if (!data)
                    return tableData;
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.status = {
                        type: 'status',
                        status: item.active,
                        label: item.active ? 'Active' : 'Inactive'
                    };
                    item.href = `/areas/routes/details/${item.id}`;
                    item.numberOfWaypoints = item.numberOfWaypoints || 0;
                    item.areaId = angular.getObjVal(item, 'area.areaId') || 'N/A';

                    tableData.data.push(item);
                });
            }
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/RoutesTableService.js